const VERSION = '2.0.23b'
export default VERSION
